import '@angular/compiler';
import { PageReviewProjectsComponent } from './page.review.projects/page.review.projects.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageEntityReviewsItemComponent } from './page.entity.reviews.item/page.entity.reviews.item.component';
import { PageReviewTaskItemComponent } from './page.review.task.item/page.review.task.item.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageEntityReviewsComponent } from './page.entity.reviews/page.entity.reviews.component';
import { PageQaOperatorComponent } from './page.qa.operator/page.qa.operator.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageReviewTaskDatasetComponent } from './page.review.task.dataset/page.review.task.dataset.component';
import { PageReviewResultItemComponent } from './page.review.result.item/page.review.result.item.component';
import { PageReviewSurveyComponent } from './page.review.survey/page.review.survey.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageHarnessesItemComponent } from './page.harnesses.item/page.harnesses.item.component';
import { PageEntityProjectsComponent } from './page.entity.projects/page.entity.projects.component';
import { PageReviewProjectsItemComponent } from './page.review.projects.item/page.review.projects.item.component';
import { PageExpertsComponent } from './page.experts/page.experts.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageHarnessesComponent } from './page.harnesses/page.harnesses.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageHumanReviewsComponent } from './page.human.reviews/page.human.reviews.component';
import { PageKgReviewsComponent } from './page.kg.reviews/page.kg.reviews.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageProjectResourceEditorComponent } from './page.project.resource.editor/page.project.resource.editor.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageEntityProjectsItemComponent } from './page.entity.projects.item/page.entity.projects.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageSurveysComponent } from './page.surveys/page.surveys.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "review-projects",
                component: PageReviewProjectsComponent,
                "app_id": "page.review.projects"
            },
            {
                "path": "entity-reviews/:id",
                component: PageEntityReviewsItemComponent,
                "app_id": "page.entity.reviews.item"
            },
            {
                "path": "review-tasks/:kind/:id",
                component: PageReviewTaskItemComponent,
                "app_id": "page.review.task.item"
            },
            {
                "path": "entity-reviews",
                component: PageEntityReviewsComponent,
                "app_id": "page.entity.reviews"
            },
            {
                "path": "qa-operator",
                component: PageQaOperatorComponent,
                "app_id": "page.qa.operator"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "review-tasks/qa/:id/dataset",
                component: PageReviewTaskDatasetComponent,
                "app_id": "page.review.task.dataset"
            },
            {
                "path": "review-results/:kind/:id",
                component: PageReviewResultItemComponent,
                "app_id": "page.review.result.item"
            },
            {
                "path": "review-surveys/:kind/:taskId",
                component: PageReviewSurveyComponent,
                "app_id": "page.review.survey"
            },
            {
                "path": "harnesses/:id",
                component: PageHarnessesItemComponent,
                "app_id": "page.harnesses.item"
            },
            {
                "path": "entity-projects",
                component: PageEntityProjectsComponent,
                "app_id": "page.entity.projects"
            },
            {
                "path": "review-projects/:id/:tab?",
                component: PageReviewProjectsItemComponent,
                "app_id": "page.review.projects.item"
            },
            {
                "path": "experts",
                component: PageExpertsComponent,
                "app_id": "page.experts"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "harnesses",
                component: PageHarnessesComponent,
                "app_id": "page.harnesses"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "human-reviews",
                component: PageHumanReviewsComponent,
                "app_id": "page.human.reviews"
            },
            {
                "path": "kg-reviews",
                component: PageKgReviewsComponent,
                "app_id": "page.kg.reviews"
            },
            {
                "path": "review-projects/:projectId/resource-editor/:kind/:resourceId",
                component: PageProjectResourceEditorComponent,
                "app_id": "page.project.resource.editor"
            },
            {
                "path": "entity-projects/:id",
                component: PageEntityProjectsItemComponent,
                "app_id": "page.entity.projects.item"
            },
            {
                "path": "surveys",
                component: PageSurveysComponent,
                "app_id": "page.surveys"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }